export const MODAL_NAMES = {
  RESET_PASSWORD: 'reset-password',
  CONFIRM_EMAIL: 'confirm-email',
};
